import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { ticketNotesOrderedListSelectorFactory } from '@/redux/app/selectors/ticket';
import { Event } from '../../../event';

export interface TicketChannelProps {
  ticket: string;
}

export const NotesList = ({ ticket }: TicketChannelProps) => {
  const noteListSelector = useMemo(() => ticketNotesOrderedListSelectorFactory(ticket), [ticket]);
  const notes = useSelector(noteListSelector);
  return (
    <div className="ticket-notes">
      {notes?.map((id) => <Event key={id} id={id} ticket={ticket} />)}
    </div>
  );
};
